/* 🤖 this file was generated by svg-to-ts */
export const matIconCallReceived: {
  name: 'call-received';
  data: string;
} = {
  name: 'call-received',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M20 5.41 18.59 4 7 15.59V9H5v10h10v-2H8.41L20 5.41z"/></svg>`
};
